import type { FC } from 'react';
import React, { useMemo } from 'react';

import type { TTableRow } from './models';
import { BORDER_RADIUS_SIZES } from './constants';

export const TableRow: FC<TTableRow> = ({
    background,
    borderRadius = 24,
    children,
    dataTestId,
    marginTop,
    styles,
}) => {
    const mainTrStyle = useMemo(() => (background ? { background } : undefined), [background]);

    const rowBorderRadiusSize = useMemo(() => {
        /** TODO: удалить проверку после миграции на новый формат.
         * Вернуть BORDER_RADIUS_CLASS[borderRadius].
         */
        if (typeof borderRadius === 'number') return BORDER_RADIUS_SIZES[borderRadius];
        if (borderRadius) return BORDER_RADIUS_SIZES[4];

        return BORDER_RADIUS_SIZES[0];
    }, [borderRadius]);

    return (
        <>
            {marginTop && <tr style={{ height: marginTop }} />}
            <tr
                className={styles[`rowBorderRadius${rowBorderRadiusSize}`]}
                data-test-id={dataTestId}
                style={mainTrStyle}
            >
                {children}
            </tr>
        </>
    );
};
